import { useMemo } from 'react';

export const useAllowedAmount = ({ balance, bonusTemplate, amounts }) => {
    const { bonusConditions = [] } = bonusTemplate || {};

    return useMemo(() => {
        const amountsAll = amounts.map((amount) => amount.toAmount);

        const monthlyAmountsAll = bonusConditions
            .flatMap((bonusCondition) => {
                const { totals } = bonusCondition;

                return totals.map((total) => total.monthlyAmount);
            });

        return Math.min(Number(balance), ...amountsAll, ...monthlyAmountsAll);
    }, [
        amounts,
        balance,
        bonusConditions
    ]);
};
